import { useParams } from "react-router-dom"
import config from "../../../../config/config"
import CustomListContainer from "../../../../../core/components/core/Util/List/CustomList/CustomListContainer"
import CustomList from "../../../../../core/components/core/Util/List/CustomList/CustomList"
import Toast from "../../../../../core/components/core/Util/Toast/Toast"
import Fetch from "../../../../../core/util/core/Fetch"

function Phones() {
  const { id } = useParams()

  const pathFrontEnd = '/projectmanagers/'
  const pathBackEnd = config.endpoints.backend + 'projectmanagers/'

  const paths = {
    endpoint: `${pathBackEnd}getPhonesByManagerId`,
    endpointDelete: `${pathBackEnd}deletePhone`,
    endpointSave: `${pathBackEnd}savePhone`,
    endpointGetById: `${pathBackEnd}getByPhoneId`,

    urlGoBack: `${pathFrontEnd}list`
  }

  const labels = {
    labelTitleEdit: "Editar Contato",
    labelTitleView: "Visualizar Contato",
    labelTitleAdd: "Novo Contato"
  }

  const form = {
    containerType: 'dialog',
    validateOnChange: true,
    hiddenValues: {
      manager_id: id
    },
    fields: [
      {
        label: 'Tipo',
        type: 'select',
        options: [{
          label: "Tel. Institucional",
          value: "TELINSTITUCIONAL"
        },
        {
          label: "Tel. Fixo",
          value: "TELFIXO"
        },
        {
          label: "Recado",
          value: "RECADO"
        },
        {
          label: "Comercial",
          value: "COMERCIAL"
        },
        {
          label: "Residencial",
          value: "RESIDENCIAL"
        },
        {
            label: "Celular",
            value: "CELULAR"
        }],
        name: 'type',
        validations: {
          required: true
        }
      },
      {
        label: 'Telefone',
        type: 'phone',
        name: 'phone',
        validations: {
          required: true
        }
      }
    ],
    ...paths,
    ...labels
  }

  const list = {
    type: 'dialog',
    labelTitle: 'Lista de Contatos',
    handleConfirmDelete: async (item) => {
      const response = await Fetch.delete(paths.endpointDelete, { phone_id: item.id, id })
      const { status } = response
      if (status === 0) {
        Toast.error('Erro ao deletar o contato');
        return false
      }
      Toast.success('Contato deletado com sucesso');
    },
    filter: {
      id
    },
    fieldsShowOnDelete: ['phone'],
    columns: [
      {
        name: 'label',
        label: 'Tipo',
      },
      {
        name: 'phone',
        label: 'Telefone'
      }
    ],
    ...paths,
    ...labels
  };

  list.form = form;

  return (
    <CustomListContainer
      labelTitle={list.labelTitle}
      labelTitleButtonAdd={list.labelTitleAdd}
      list={list}
      form={form}
      showInnerModal={false}
      content={<CustomList list={list} />}
    />
  )
}

export default Phones
